import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getUnidadesAll() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("unidades/access/listarTodas").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getUnidades(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("unidades/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getUnidadesBox(context, filtros) {
        filtros.componente = "SearchBoxUnidade";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("unidades/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getUnidade(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("unidades/access/obter", {ID_UNIDADE: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getLocalUnidadeSimples(context, idUnidade) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("unidades/access/obterSimples", {ID_UNIDADE: idUnidade}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deleteUnidade(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("unidades/access/excluir", {ID_UNIDADE: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postUnidade(context, unidade) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("unidades/access/salvar", unidade).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPlanosInfo(context, idUnidade) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("unidades/access/listarUnidadesPlanosInfo", {ID_UNIDADE:idUnidade}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};